import { makeAutoObservable, toJS } from 'mobx'
import api from '../utils/axiosAuthInterceptor'
import { notification } from 'antd'
import i18next from 'i18next'
const axios = api

class AccessoriesNewStore {
  newAccessories = []
  isMainLoading = false
  totalAcessories = 0
  filterParams = {
    pageSize: 10,
    page: 1,
    productGroups: [],
    categoryA: [],
    categoryB: [],
    supplierModels: [],
    abbreviations: [],
    accessory_name: [],
  }
  accessoriesNewModal = {
    open: false,
    edit: {
      id: null,
      isEdit: false,
    },
    options: {
      categoryA: [],
      categoryB: [],
      productGroups: [],
      supplierModels: [],
      abbreviations: [],
    },
    data: {
      categoryA: null,
      categoryB: null,
      productGroups: [],
      supplierModels: [],
      abbreviations: [],
      accessory_name: '',
    },
    initialAccessoryBeforeEdit: {
      categoryA: null,
      categoryB: null,
      productGroups: [],
      supplierModels: [],
      abbreviations: [],
      accessory_name: '',
    },
  }

  constructor() {
    makeAutoObservable(this, {}, { deep: true })
  }

  //Common

  openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
      placement: 'bottomRight',
    })
  }

  changeSize = (current, size) => {
    this.filterParams.pageSize = size
  }

  changePage = async (e) => {
    this.filterParams.page = e.current
    await this.getNewAccessories()
  }

  //Main table

  getNewAccessories = async () => {
    try {
      const params = this.filterParams
      this.isMainLoading = true
      const response = await axios.get('/api/node/v1/accessoriesNew', {
        params,
      })
      this.newAccessories = response.data.data.rows
      this.totalAcessories = response.data.data.count
    } catch (error) {
      this.openNotificationWithIcon('error', i18next.t('w_error'))
    } finally {
      this.isMainLoading = false
    }
  }

  deleteNewAccessories = async (id) => {
    try {
      this.isMainLoading = true
      await axios.delete(`/api/node/v1/accessoriesNew/${id}`)
      await this.getNewAccessories()
      this.openNotificationWithIcon('success', i18next.t('w_success'))
    } catch (error) {
      this.openNotificationWithIcon('error', i18next.t('w_error'))
    }
  }

  //Accessories New modal
  getOptionsAccessoriesNewModal = async () => {
    try {
      const params = this.accessoriesNewModal.data
      const response = await axios.get('/api/node/v1/accessoriesNew/options', {
        params,
      })
      this.accessoriesNewModal.options = response.data.data
    } catch (error) {
      this.openNotificationWithIcon('error', i18next.t('w_error'))
    }
  }

  onFinishAccessoriesNewModal = async (values, form) => {
    try {
      
      this.accessoriesNewModal.data.accessory_name =
        values.accessory_name.trim()
      if (this.accessoriesNewModal.edit.isEdit) {
        let dataForUpdate = {
          newData:  this.accessoriesNewModal.data,
          oldData: {
            ...this.accessoriesNewModal.initialAccessoryBeforeEdit,
            accessory_name: this.accessoriesNewModal.initialAccessoryBeforeEdit.accessory_name.trim()
          }
        }
        await axios.put(
          `/api/node/v1/accessoriesNew/${this.accessoriesNewModal.edit.id}`,
          dataForUpdate
        )
      } else {
        await axios.post(
          '/api/node/v1/accessoriesNew',
          this.accessoriesNewModal.data
        )
      }
      await this.clearAndGetOptionsAccessoriesNewModal(form)
      this.openNotificationWithIcon('success', i18next.t('w_success'))
    } catch (error) {
      this.openNotificationWithIcon('error', i18next.t('w_error'))
    }
  }

  openAccessoriesNewModal = async () => {
    this.accessoriesNewModal.open = true
    await this.getOptionsAccessoriesNewModal()
  }

  closeAccessoriesNewModal = async () => {
    this.accessoriesNewModal.open = !this.accessoriesNewModal.open
    await this.getNewAccessories()
  }

  onClickEditAccessoriesNewModal = async (row, form) => {
    try {
      this.accessoriesNewModal.edit.isEdit = true
      this.accessoriesNewModal.edit.id = row.id
      const onlyIds = (arr) => arr.map((el) => el.id)
      const catgoryAB = (category) => {
        if (row[category]?.length === 1) {
          return row[category][0]?.id
        } else return null
      }
      const accessoryData = {
        categoryA: catgoryAB('categoryA'),
        categoryB: catgoryAB('categoryB'),
        productGroups: onlyIds(row.productGroups),
        supplierModels: onlyIds(row.supplierModels),
        abbreviations: onlyIds(row.abbreviations),
        accessory_name: row.name,
      };

      this.accessoriesNewModal.data = accessoryData;
      this.accessoriesNewModal.initialAccessoryBeforeEdit = { ...accessoryData };

      form.setFieldsValue({
        accessory_name: row.name,
      })
      await this.openAccessoriesNewModal()
    } catch (error) {
      this.openNotificationWithIcon('error', i18next.t('w_error'))
    }
  }

  cleanAccessoriesNewModalData = (form) => {
    form.resetFields()
    this.accessoriesNewModal.edit = {
      id: null,
      isEdit: false,
    }
    this.accessoriesNewModal.data = {
      productGroups: [],
      categoryA: null,
      categoryB: null,
      abbreviations: [],
      supplierModels: [],
      accessory_name: '',
    }

    this.accessoriesNewModal.options = {
      productGroups: [],
      categoryA: [],
      categoryB: [],
      abbreviations: [],
      supplierModels: [],
    }
  }

  onClickSelectAccessoriesNewModal = async (value, type) => {
    this.accessoriesNewModal.data[type] = value
    if (type !== 'abbreviations') {
      await this.getOptionsAccessoriesNewModal()
    }
  }

  clearAndGetOptionsAccessoriesNewModal = async (form) => {
    this.cleanAccessoriesNewModalData(form)
    await this.getOptionsAccessoriesNewModal()
  }
}

export default AccessoriesNewStore
